import styled from "styled-components";
import Modal from 'react-bootstrap/Modal';

export const ModalStyled = styled(Modal)`

  backdrop-filter: blur(2px);

  hr {
    margin: 0px;
    padding: 0px;
  }

  .modal-header {
    padding: 24px;
    padding-bottom: 0px;
    border: none;
  }

  .modal-body {
    padding: 24px;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    p{
      line-height: 16px;
      color: rgba(106, 122, 143, 1);
      text-align: justify;
      letter-spacing: unset;
    }
  }

  .modal-open .modal {
    backdrop-filter: blur(2px);
  }

  .modal-528 {
    min-width: 528px;
  }

  .close {
    color: #bbc8db;
    border: 3px solid #bbc8db;
    border-radius: 50%;
    padding: 0px;
    margin: 0px;
    width: 24px;
    height: 24px;
    position: relative;
    span {
      font-size: 22px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    font-size: 20px;
  }
  .modal-title {
    margin-top: 48px;
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
    color: rgba(71, 84, 102, 1);
    flex-direction: column;
  }

  .modal-content{
    border-radius: 8px;
  }  
`;

export const ButtonStyled = styled.button`
  align-self: flex-end;
  border: none;
  background-color: #4A90E2;
  color: #fff;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  gap: 8px;
  border-radius: 24px;
  width: 156px;
  height: 40px;
  font-style: normal;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;

  svg{
    margin-left: 8px;
  }
`;